import React, { useEffect, useRef, useState } from "react";

const SobreMi = () => {
  const seccionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observador = new IntersectionObserver(
      ([entrada]) => {
        if (entrada.isIntersecting) {
          setVisible(true);
          observador.disconnect();
        }
      },
      {
        threshold: 0.2,
      }
    );

    if (seccionRef.current) {
      observador.observe(seccionRef.current);
    }

    return () => observador.disconnect();
  }, []);

  return (
    <>
      <style>
        {`
          @keyframes aparecerDesdeAbajo {
            from {
              opacity: 0;
              transform: translateY(50px);
            }

            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .sobre-mi-animacion {
            opacity: 0;
          }

          .sobre-mi-visible {
            animation: aparecerDesdeAbajo 0.8s ease-out forwards;
          }

          .sobre-mi-titulo {
            animation-delay: 0.1s;
          }

          .sobre-mi-contenido {
            animation-delay: 0.3s;
          }

          @media (prefers-reduced-motion: reduce) {
            .sobre-mi-animacion {
              opacity: 1;
              animation: none;
            }
          }
        `}
      </style>

      <section
        ref={seccionRef}
        id="sobre-mi"
        className="px-3 sm:px-6"
      >
        <div className="mx-auto max-w-[1230px] pb-14 sm:pb-20">
          <h2
            className={`sobre-mi-animacion sobre-mi-titulo relative mb-5 text-center text-[35px] font-black text-[#1c2143] sm:text-[50px] ${
              visible ? "sobre-mi-visible" : ""
            }`}
          >
            Sobre mí

            <span className="mx-auto block h-1 w-[90px] rounded-full bg-[#1c2143] sm:w-[120px]" />
          </h2>

          <div
            className={`sobre-mi-animacion sobre-mi-contenido rounded-[30px] border-2 border-[#1c2143] bg-transparent p-5 shadow-[0_20px_60px_rgba(28,33,67,0.15)] backdrop-blur-[20px] transition duration-300 hover:-translate-y-1 hover:shadow-[0_0_40px_rgba(28,33,67,0.25)] sm:p-10 ${
              visible ? "sobre-mi-visible" : ""
            }`}
          >
            <p className="text-base leading-8 text-black sm:text-xl">
              Soy Técnico Universitario en Programación, egresado de la UTN-FRT,
              y actualmente formo parte del sector de IT de Scania Argentina
              como pasante.

              <span className="block h-4" />

              Me considero una persona organizada, responsable y comprometida.
              Disfruto del trabajo colaborativo, aportar ideas y afrontar nuevos
              desafíos, adaptándome a diferentes situaciones y entornos de
              trabajo.

              <span className="block h-4" />

              Me interesa especialmente el desarrollo web, la creación de
              soluciones digitales y la optimización de la experiencia del
              usuario. Tengo una actitud de aprendizaje continuo y curiosidad por
              conocer nuevas tecnologías y formas de resolver problemas.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default SobreMi;